export const CLEAR_DASHBOARD_FILTERS = 'CLEAR_DASHBOARD_FILTERS';
export const FILTER_DASHBOARD = 'FILTER_DASHBOARD';
export const REFRESH_DASHBOARD = 'REFRESH_DASHBOARD';